import { Box, Drawer } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { useMap } from '@vis.gl/react-google-maps';
import { useAtom } from 'jotai';
import { type ReactNode, useEffect } from 'react';
import { teamDetailPanelVisible } from '@/common/atoms/community';
import { moveMapPinIntoView } from '../../utils/moveMapPinIntoView';

interface Props {
  teamId?: string;
  children: ReactNode;
}

export const PartnerDetailsWrapper = ({ teamId, children }: Props) => {
  const isMobile = useIsMobile('md');
  const [isTeamDetailsOpen, setTeamDetailsOpen] = useAtom(
    teamDetailPanelVisible,
  );
  const map = useMap();

  const handleClose = () => {
    setTeamDetailsOpen(false);
  };

  // If active pin is covered by popper, scroll into view
  useEffect(() => {
    if (isMobile || !map || !isTeamDetailsOpen) return;

    moveMapPinIntoView(map);
  }, [isMobile, isTeamDetailsOpen, map, teamId]);

  if (isMobile) {
    return (
      <Drawer
        open={isTeamDetailsOpen}
        anchor="bottom"
        onClose={handleClose}
        variant="temporary"
        sx={{
          '& .MuiDrawer-paper': {
            height: '100dvh',
          },
        }}
      >
        {children}
      </Drawer>
    );
  }

  if (!isTeamDetailsOpen) {
    return null;
  }

  return (
    <Box
      id="partner-details"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'common.white',
        width: 380,
        maxHeight: 'calc(100% - 32px)',
        border: (theme) => `1px solid ${theme.palette.other.outlineBorder}`,
        borderRadius: '5px',
        position: 'absolute',
        m: 2,
        overflow: 'hidden',
        top: 0,
      }}
    >
      {children}
    </Box>
  );
};
